import {
  LibraryActions,
  type LibraryItem,
  selectLibraryItem,
} from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { call, put, select } from 'redux-saga/effects'

import { deleteLibraryItem } from '@/services/library'
import type { LibrarySagaActions } from '../actions'
import { LibraryNotifications } from '../notifications'
import { purgeMissingSymbols } from './purgeMissingSymbols'

/** Deletes the symbol for good; this project purges its ref right away. */
export function* removeLibrarySymbol({
  payload: { libraryId },
}: ReturnType<typeof LibrarySagaActions.removeSymbol>) {
  const item: LibraryItem<'symbol'> | undefined = yield select(
    selectLibraryItem('symbol', libraryId)
  )

  if (!item) {
    return
  }

  const workspaceId: string = yield select(
    migrationProjectSelector.getLibraryWorkspaceParam
  )

  try {
    yield call(deleteLibraryItem, workspaceId, 'symbol', libraryId)

    yield put(LibraryActions.remove({ kind: 'symbol', ids: [libraryId] }))
    yield put(LibraryNotifications.removed)
    yield call(purgeMissingSymbols)
  } catch (error) {
    console.error('Failed to remove the symbol from the library', error)

    yield put(
      LibraryNotifications.failed(
        'Failed to remove the symbol from the library'
      )
    )
  }
}
